import { ApiClientBase } from "api/ApiClientBase";

class DashboardApiClient extends ApiClientBase {
    getMapFilters() {
        return this.get(`/api/v1/dashboard/map/filters`).then((r) => r.data);
    }

    getMapData(sportType, sex, sportTrainingLevel) {
        const query = {
            sportType,
            sex,
            sportTrainingLevel,
        };
        return this.get(`/api/v1/dashboard/map`, query).then((r) => r.data);
    }

    getSportsmansData(sportType, sex, sportTrainingLevel, regionId, schoolId) {
        const query = {
            sportType,
            sex,
            sportTrainingLevel,
            regionId,
            schoolId,
        };

        return this.get(`/api/v1/dashboard/sportsman`, query).then((r) => r.data);
    }

    getSchoolsFromRegion(regionId, sportTypeId) {
        if (!regionId) return null;
        const query = {
            sportTypeId,
        };

        return this.get(`/api/v1/dashboard/map/${regionId}/schools`, query).then((r) => r.data);
    }

    getSportsmanData(sportsmanId) {
        return this.get(`/api/v1/dashboard/sportsman/${sportsmanId}`).then((r) => r.data);
    }
}

// eslint-disable-next-line import/no-anonymous-default-export
export default new DashboardApiClient();
